import React, { useEffect, useState } from "react";
import Sidebar from "../../components/ui/AppShell/Sidebar";
import { Box, Flex, Modal, Pagination, ScrollArea, Text, TextInput, rem } from "@mantine/core";
import classes from "./historyWeb.module.css";
import { useMediaQuery } from "@mantine/hooks";
import { IconSearch } from "@tabler/icons-react";
import TableSkeleton from "../../components/ui/TableSkeleton";
import TableHistoryWeb from "../../components/pages/historyWeb/TableHistoryWeb";
import FormHistoryWeb from "../../components/pages/historyWeb/FormHistoryWeb";
import { getListHistoryWeb } from "../../services/historyWeb";

const defaultParameter = {
  skip: 0,
  take: 10,
  keywords: "",
  orderBy: "createdAt",
  order: "desc",
};

const labelTable = [
  {
    label: "No.",
    width: 30,
  },
  {
    label: "User",
    width: "auto",
  },
  {
    label: "App",
    width: "auto",
  },
  {
    label: "Login Time",
    width: "auto",
  },
];

const HistoryWeb = () => {
  const isSmallScreen = useMediaQuery("(max-width: 425px)");
  const [historyWebList, setHistoryWebList] = useState([]);
  const [params, setParams] = useState(defaultParameter);
  const [count, setCount] = useState(0);
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);

  const handleGetHistoryWebList = async () => {
    setLoading(true);
    try {
      const response = await getListHistoryWeb(params);
      setHistoryWebList(response.data);
      setCount(response.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetHistoryWebList();
    // eslint-disable-next-line
  }, [params]);

  const handleSearchChange = (e) => {
    const params = {
      skip: 0,
      take: 10,
      keywords: e.target.value,
      orderBy: "createdAt",
      order: "desc",
    };
    setParams(params);
  };

  const handleChangePage = (e) => {
    const params = {
      skip: (e - 1) * 10,
      take: 10,
      keywords: "",
      orderBy: "createdAt",
      order: "desc",
    };
    setParams(params);
  };

  const onCloseModalForm = () => {
    setOpenModalForm(false);
    setDetailData(null);
  };

  return (
    <Sidebar>
      <Box>
        <Text className={classes.titlePage} mb={20}>
          History Login User
        </Text>
      </Box>
      <Box style={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", justifyContent: "space-between" }}>
        <Flex>
          <TextInput leftSectionPointerEvents="none" leftSection=<IconSearch style={{ width: rem(16), height: rem(16) }} /> placeholder="Cari Employee. . ." name="search" onChange={handleSearchChange} />
        </Flex>
      </Box>
      <Box my={20}>{loading ? <TableSkeleton total={5} /> : <TableHistoryWeb label={labelTable} data={historyWebList} countData={params.skip} />}</Box>
      <Flex justify="end">
        <Pagination onChange={handleChangePage} total={Math.ceil(count / params.take) || 0} color="#0572b9" radius="lg" />
      </Flex>
      <Modal
        opened={openModalForm}
        onClose={onCloseModalForm}
        centered
        closeOnClickOutside={false}
        size="lg"
        title={<Text fw="Bold">{detailData ? "Edit Organisasi" : "Tambah Organisasi"}</Text>}
        scrollAreaComponent={ScrollArea.Autosize}
        withCloseButton={false}
      >
        <FormHistoryWeb onCloseModal={onCloseModalForm} />
      </Modal>
    </Sidebar>
  );
};

export default HistoryWeb;
